import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 18"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13.45 2.96H9.2c-.4 0-.78.15-1.06.44L1.47 9.97c-.59.59-.59 1.55 0 2.14l4.35 4.35c.29.29.67.44 1.07.44s.78-.16 1.07-.44l6.57-6.67c.28-.29.44-.66.44-1.06V4.47a1.53 1.53 0 0 0-1.52-1.51zm.91 5.76a.9.9 0 0 1-.26.64l-6.57 6.67a.915.915 0 0 1-1.3 0l-4.35-4.35a.905.905 0 0 1 0-1.29l6.67-6.57a.9.9 0 0 1 .64-.26h4.25c.5 0 .91.41.91.91v4.25z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.8 5.48c-.36 0-.65.29-.65.65s.29.65.65.65c.36 0 .65-.29.65-.65s-.29-.65-.65-.65z"
    }, null, -1)
  ])))
}
export default { render };